import type { ChartType } from '../types';

interface ChartTypeToggleProps {
  value: ChartType;
  onChange: (value: ChartType) => void;
}

export function ChartTypeToggle({ value, onChange }: ChartTypeToggleProps): JSX.Element {
  return (
    <div className="inline-flex rounded-md border border-brand-dark-lighter overflow-hidden bg-brand-dark-lighter">
      <button
        onClick={() => onChange('bar')}
        title="Grafico de Barras"
        className={`
          py-1.5 px-2.5 border-none cursor-pointer text-base transition-all duration-150 flex items-center justify-center
          ${value === 'bar'
            ? 'bg-brand-primary text-brand-dark'
            : 'bg-transparent text-brand-gray hover:bg-brand-dark'
          }
        `}
      >
        Bar
      </button>
      <button
        onClick={() => onChange('line')}
        title="Grafico de Linha"
        className={`
          py-1.5 px-2.5 border-none border-l border-brand-dark-lighter cursor-pointer text-base transition-all duration-150 flex items-center justify-center
          ${value === 'line'
            ? 'bg-brand-primary text-brand-dark'
            : 'bg-transparent text-brand-gray hover:bg-brand-dark'
          }
        `}
      >
        Line
      </button>
    </div>
  );
}
